module.exports = __webpack_public_path__ + "img/unlocked.e8b3b7b8.svg";